import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

const ForgotPasswordForm = ({
  layout
}: {
  layout?: 'simple' | 'card' | 'split';
}) => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { handleResetPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    const trimmed = email.trim();
    if (!trimmed) {
      setErrorMessage('Please enter your email address.');
      return;
    }
    setIsLoading(true);
    const result = await handleResetPassword(trimmed);
    setIsLoading(false);
    if (result.success) {
      navigate('../reset-password', { state: { email: trimmed } });
    } else {
      setErrorMessage(result.message);
    }
  };

  return (
    <div className={classNames({ 'px-xxl-5': !(layout === 'split') })}>
      <div
        className={classNames('text-center', { 'mb-6': !(layout === 'split') })}
      >
        <h4 className="text-1000">Forgot your password?</h4>
        <p className="text-700 mb-5">
          Enter your email below and we will send <br className="d-sm-none" />
          you a reset code
        </p>
        <Form className="d-flex align-items-center mb-5" onSubmit={handleSubmit}>
          <Form.Control
            type="email"
            id="email"
            className="flex-1"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            autoComplete="email"
          />
          <Button
            type="submit"
            variant="primary"
            className="ms-2"
            disabled={isLoading}
            endIcon={<FontAwesomeIcon icon={faChevronRight} className="ms-2" />}
          >
            {isLoading ? 'Sending…' : 'Send'}
          </Button>
        </Form>
        {errorMessage && (
          <div className="text-danger small mb-3">{errorMessage}</div>
        )}
        <Link to="#!" className="fs-9 fw-bold">
          Still having problems?
        </Link>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
